/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function No({
  children,
  viewPath = "/App/Widget/Content/Questions/Complete/MedicalForm/Content/MedicalFormUrl/Content/No"
  
}) {
  return null
}